import { render, staticRenderFns } from "./sub-order-modal.vue?vue&type=template&id=19bc5ccf&scoped=true&"
import script from "./sub-order-modal.vue?vue&type=script&lang=js&"
export * from "./sub-order-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc5ccf",
  null
  
)

export default component.exports